import React, { Component } from 'react';
import PageTitle from "../../Components/PageTitle";
import { TextBox, SubmitBtn, formatDate, SubmitButton } from "../../Components/InputElements";
import axios from 'axios';
import Swal from 'sweetalert2';
import withRouter from '../../Utils/withRouter';
import { ConfigContext } from '../../Context/ConfigContext'
import { currentDateAndTime } from '../../Constants/constants';
import { NoRecords } from '../../Components/Shimmer';
import TooltipComponent from '../../Components/TooltipComponent';
import { decodeData } from '../../Constants/constants';
class PMSCycle extends Component {
    static contextType = ConfigContext;
    constructor(props) {
        super(props);
        this.state = {
            calendar_id: 0,
            pms_cycle_id: 0,
            from_date: "",
            to_date: "",
            rows: [],
            next: false,
            prev: false,
            page: 1,
            limit: 10,
            total_records: 0,
            total_pages: 0,
            loadingList: false,
            loadingDelete: false,
            postLoading: false,
            errors: {},
            decodedData: [],

        };
    }
    componentDidMount() {
        this.setState({ loadingList: true }, (prevState) => {
            this.GetList();
        })
    }
    componentDidUpdate(prevProps, prevState) {
          if (prevState.permissions !== this.context.permissions) {
            // console.log("Permissions Updated:", this.context.permissions);
              const { permissions } = this.context;
              if (permissions.length > 0) {
                const queryParams = new URLSearchParams(window.location.search);
                const encodedData = queryParams.get("abs");
                const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
                if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
                  this.setState({ decodedData });
                }
              } else {
                console.warn("Permissions not yet available. Retrying...");
              }
          }
      }
    handleInputChange = (e) => {
        const { name, value } = e.target;

        this.setState((prevState) => ({
            [name]: value,
            errors: {
                ...prevState.errors,
                [name]: '',
            },
        }));
    };

    GetInfo = (row) => {
        // const { apiURL, apiHeaderJSON } = this.context;
        // const headers = apiHeaderJSON;
        // axios.get(`${apiURL}Masters/GetCalendarInfo?calendar_id=${this.state.calendar_id}`, { headers }).then((response) => {
        //     const { data, success } = response.data;
        //     if (success === true) {
        //         this.setState(
        //             {
        //                 from_date: data[0].from_date,
        //                 to_date: data[0].to_date,
        //             }
        //         )
        //     }
        // });
        this.setState(
            {
                pms_cycle_id: row?.pms_cycle_id,
                from_date: row?.from_date,
                to_date: row?.to_date,
            }
        )

    }
    GetList = () => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Masters/GetPMSCycleList`, { params: { limit: this.state.limit, page: this.state.page }, headers }).then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                this.setState({
                    rows: data.data,
                    next: data.next,
                    prev: data.prev,
                    page: data.page,
                    total_records: data.total_records,
                    total_pages: data.total_pages,
                    loadingList: false
                });
            } else {
                this.setState({ loadingList: false });
            }
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const errors = this.validateForm();
        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        const formData = {
            from_date: this.state.from_date,
            to_date: this.state.to_date,
            date: currentDateAndTime(),
        }

        if (this.state.pms_cycle_id !== 0) {
            formData.pms_cycle_id = this.state.pms_cycle_id;
        }

        axios.post(`${apiURL}Masters/CreatePMSCycle`, formData, { headers })
        .then((response) => {
            const { success } = response.data;
            if (success === true) {
                this.setState({
                    from_date: "",
                    to_date: "",
                }, () => {
                    this.resetForm();
                });

                this.setState({ loadingList: true }, (prevState) => {
                    this.GetList();
                })
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            } else {
                Swal.fire({
                    title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                    text: response.data.message,
                    icon: response.data.success === true ? 'success' : 'error',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            }

        }).catch((error)=>{
            console.log("ERROR",error);
            Swal.fire({ 
                title: `<strong>Failed</strong>`, 
                text: 'Opps...! Something went wrong.', 
                icon: 'error', 
                showConfirmButton: true,
                allowOutsideClick:false, 
            });
        }).finally(this.setState({postLoading:false}));
    };

    validateForm() {
        const errors = {};

        if (!this.state.from_date) {
            errors.from_date = 'From date is required';
        }
        if (!this.state.to_date) {
            errors.to_date = 'To date is required';
        }

        return errors;
    }

    resetForm = () => {
        this.setState({
            calendar_id: 0,
            pms_cycle_id: 0,
            from_date: '',
            to_date: '',
        });
    };

    handleDelete = (id) => {
        const { apiURL, apiHeaderJSON } = this.context;
        const headers = apiHeaderJSON;
        Swal.fire(
            {
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }
        ).then((result) => {
            if (result.isConfirmed) {
                this.setState({ status: true, loadingDelete:true });
                const formData = {
                    pms_cycle_id: id,
                    date: currentDateAndTime(),
                };
                axios
                    .post(`${apiURL}Masters/DeletePMSCycle`, formData, { headers })
                    .then((response) => {
                        Swal.fire({
                            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
                            text: response.data.message,
                            icon: response.data.success === true ? 'success' : 'error',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        });
                        this.setState({ status: false, loadingDelete:false });
                        if (response.data.success === true) {
                            this.setState({ loadingList: true }, (prevState) => {
                                this.GetList();
                            })
                        }
                    }).catch((error)=>{
                        console.log("ERROR",error);
                        Swal.fire({ 
                            title: `<strong>Failed</strong>`, 
                            text: 'Opps...! Something went wrong.', 
                            icon: 'error', 
                            showConfirmButton: true,
                            allowOutsideClick:false, 
                        });
                    }).finally(this.setState({loadingDelete:false}));
            }
        });
    }

    handlePrev = (ev) => {

        if (this.state.prev === true) {
            this.setState((prevState) => {
                return { page: prevState.page - 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleNext = () => {

        if (this.state.next === true) {
            this.setState((prevState) => {
                return { page: prevState.page + 1 };
            }, () => {
                this.GetList();
            });
        }
    }
    handleChange = (e) => {

        this.setState((prevState) => {
            return { page: parseInt(e.target.value, 10) };
        }, () => {
            this.GetList();
        });
    }

    render() {
        const { errors } = this.state;
        return (
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <br />
                        <PageTitle title={`PMS Cycle`} primary={`Home`} />
                        <div className="row">
                            <div className="col-md-5">
                                <div className="card">
                                    <div className="card-header align-items-center d-flex">
                                        <h4 className="card-title mb-0 flex-grow-1">PMS Cycle</h4>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gy-4">
                                            <div className="col-md-12">
                                                <form className="row">
                                                    <div className="col-md-6">
                                                        <label htmlFor="from_date" className="form-label">From Date</label>
                                                        <input
                                                            type="date"
                                                            id="from_date"
                                                            name="from_date"
                                                            value={this.state.from_date}
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            className={`form-control ${errors.from_date ? 'is-invalid' : ''}`}
                                                            onChange={this.handleInputChange}
                                                        />
                                                        {errors.from_date && <div className="text-danger">{errors.from_date}</div>}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label htmlFor="to_date" className="form-label">To Date</label>
                                                        <input
                                                            type="date"
                                                            id="to_date"
                                                            name="to_date"
                                                            value={this.state.to_date}
                                                            disabled={(!this.state.decodedData?.includes(2) && !this.state.decodedData?.includes(3))}
                                                            className={`form-control ${errors.to_date ? 'is-invalid' : ''}`}
                                                            onChange={this.handleInputChange}
                                                        />
                                                        {errors.to_date && <div className="text-danger">{errors.to_date}</div>}
                                                    </div>
                                                    { (this.state.decodedData?.includes(2) || this.state.decodedData?.includes(3)) && (
                                                    <div className="col-md-12" style={{ marginTop: "30px" }}>
                                                        {
                                                            // this.state.pms_cycle_id !== 0 ? <SubmitBtn icon={`ri-save-line`} text={`Update`} type={`primary`} status={this.state.status} /> : <SubmitBtn text={`Save`} type={`primary`} icon={`ri-save-line`} />
                                                            !this.state.decodedData?.includes(2) && this.state.decodedData?.includes(3)  ? (
                                                                <SubmitButton onClick={(e)=>{ 
                                                                    this.handleSubmit(e)
                                                                }}
                                                                disabled={!this.state.pms_cycle_id}
                                                                buttonName={'Update'} icon={'ri-save-line'} 
                                                                type='primary' iconSide='left' />) : (
                                                                <SubmitButton onClick={(e)=>{ 
                                                                        this.handleSubmit(e)
                                                                    }}
                                                                buttonName={this.state.pms_cycle_id ? 'Update':'Save'} icon={'ri-save-line'} 
                                                                type='primary' iconSide='left' />)
                                                        }

                                                        {
                                                            this.state.pms_cycle_id !== 0 ? <button style={{ float: 'right' }} type="button" className={`btn btn-danger right btn-label`} onClick={() => this.resetForm()} ><i className={` ri-close-line label-icon align-middle fs-16 ms-2`} />Cancel</button> : <div></div>

                                                        }
                                                    </div>)}
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-7">
                                <div className='card'>
                                    <div className="col-md-12">
                                        <table className={`table table-bordered table-stripped`}>
                                            <thead className='table-light'>
                                                <tr>
                                                    <th>From Date</th>
                                                    <th>To Date</th>
                                                    { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                    <th width={120}>Action</th>)}
                                                </tr>
                                            </thead>
                                            {this.state.rows.length===0?
                                            <tbody>
                                                <tr>
                                                    <td colSpan={4}>
                                                        <NoRecords/>
                                                    </td>
                                                </tr>
                                            </tbody>:
                                            <tbody>
                                                {
                                                    this.state.rows.map((row) => {
                                                        return <tr key={row.pms_cycle_id}>
                                                            <td>{formatDate(row.from_date)}</td>
                                                            <td>{formatDate(row.to_date)}</td>
                                                            { (this.state.decodedData?.includes(3) || this.state.decodedData?.includes(4)) && (
                                                            <td className='d-flex justify-content-around'>
                                                                { this.state.decodedData?.includes(3) && (
                                                                <TooltipComponent name="Edit" position="bottom">
                                                                    <button type='button' onClick={() => this.GetInfo(row)} className="btn-icon btn btn-sm btn-outline-primary"> <i className="ri-edit-box-line"></i> </button>
                                                                </TooltipComponent>)}
                                                                { this.state.decodedData?.includes(4) && (
                                                                <TooltipComponent name="Delete" position="bottom">
                                                                    <button 
                                                                    onClick={() => {
                                                                        if(!this.state.loadingDelete){
                                                                            this.handleDelete(row.pms_cycle_id);
                                                                        }
                                                                        }} 
                                                                    className="btn-icon btn btn-sm btn-outline-danger"> 
                                                                    {this.state.loadingDelete ? (
                                                                        <span
                                                                            class="spinner-border flex-shrink-0"
                                                                            role="status"
                                                                            style={{
                                                                            width: "0.8rem",
                                                                            height: "0.8rem",
                                                                            borderWidth: "2px",
                                                                            }}
                                                                        >
                                                                            <span class="visually-hidden">Loading...</span>
                                                                        </span>
                                                                        ) : (
                                                                            <i className="ri-delete-bin-line"></i> 
                                                                        )}
                                                                    </button>
                                                                </TooltipComponent>)}
                                                            </td>)}
                                                        </tr>
                                                    })
                                                }
                                            </tbody>
                                            }
                                            {this.state.rows.length >10 && (
                                                <tfoot className='table-light'>
                                                <tr>
                                                    <th colSpan={5} >
                                                        <div className="d-flex justify-content-between" >
                                                            <button disabled={this.state.prev === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                                            <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                                                {
                                                                    <small>Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}</small>
                                                                }
                                                            </div>
                                                            <div className='col-md-2'>
                                                                <select className="form-select" onChange={(e) => this.handleChange(e)}>
                                                                    {Array.from({ length: this.state.total_pages }, (_, i) => (
                                                                        <option selected={this.state.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                            <button disabled={this.state.next === false && this.state.loadingList === false ? true : false} type="button" onClick={() => this.handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </tfoot>
                                            )}
                                            

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }; s
}
export default withRouter(PMSCycle);